"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanel = exports.Tab = exports.Tabs = void 0;
const react_1 = __importStar(require("react"));
const TabsContext = (0, react_1.createContext)(undefined);
const TabsProvider = ({ children, defaultActiveTab = 0 }) => {
    const [activeTab, setActiveTab] = (0, react_1.useState)(defaultActiveTab);
    const contextValue = (0, react_1.useMemo)(() => ({ activeTab, setActiveTab }), [activeTab]);
    return (react_1.default.createElement(TabsContext.Provider, { value: contextValue }, children));
};
const useTabs = () => {
    const context = (0, react_1.useContext)(TabsContext);
    if (!context) {
        throw new Error('useTabs must be used within a TabsProvider');
    }
    return context;
};
const Tabs = ({ children, defaultActiveTab }) => {
    return react_1.default.createElement(TabsProvider, { defaultActiveTab: defaultActiveTab }, children);
};
exports.Tabs = Tabs;
const Tab = ({ index, label, className, defaultActive, onClick }) => {
    const { activeTab, setActiveTab } = useTabs();
    const isActive = activeTab === index;
    react_1.default.useEffect(() => {
        if (defaultActive) {
            setActiveTab(index);
        }
    }, [defaultActive, index, setActiveTab]);
    const buttonClass = `
        w-full py-4 px-4 text-left font-poppinsRegular border-b border-b-lightgray2 text-base
        ${isActive ? 'bg-brandSecondary text-brandWhite' : 'bg-transparent focus-visible:outline-brandSecondary'}
    `;
    const handleClick = () => {
        setActiveTab(index);
        if (onClick) {
            onClick(index);
        }
    };
    return (react_1.default.createElement("button", { onClick: handleClick, className: `${buttonClass} ${className}`, role: "tab", "aria-selected": isActive, "aria-controls": `tabpanel-${index}`, id: `tab-${index}` }, label));
};
exports.Tab = Tab;
const TabPanel = ({ index, children, className }) => {
    const { activeTab } = useTabs();
    return activeTab === index ? (react_1.default.createElement("div", { id: `tabpanel-${index}`, tabIndex: -1, className: `tabpanel ${className}`, role: "tabpanel", "aria-labelledby": `tab-${index}` }, children)) : null;
};
exports.TabPanel = TabPanel;
